import { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../components/dashboard-layout";

const QUICK_ACTIONS = [
  { icon: "💬", color: "#3B82F6", bg: "#EFF6FF", title: "Mulai Chat", desc: "Tanya apa saja tentang Arduino ke AI", to: "/chatbot" },
  { icon: "📋", color: "#10B981", bg: "#F0FDF4", title: "Template Kode", desc: "Jelajahi 17+ template siap pakai", to: "/template" },
  { icon: "💚", color: "#25D366", bg: "#F0FDF4", title: "WhatsApp Kami", desc: "Chat langsung dengan tim support", href: "https://wa.me/6282132896737" },
  { icon: "✉️", color: "#F59E0B", bg: "#FFFBEB", title: "Email Dukungan", desc: "Kirim pertanyaan ke tim kami", href: "mailto:AiDuNode@gmail.com" },
  { icon: "🌐", color: "#8B5CF6", bg: "#F5F3FF", title: "Website Resmi", desc: "Kunjungi AiDuNode.com", href: "https://www.AiDuNode.com" },
];

const FAQS = [
  {
    category: "🤖 Chatbot AI",
    color: "#3B82F6",
    items: [
      { q: "Bagaimana cara menggunakan chatbot AiDuNode?", a: "Buka menu \"Chatbot AI\" di sidebar kiri, lalu ketikkan pertanyaan kamu seputar Arduino, ESP32, NodeMCU, atau elektronik. AI akan menjawab dengan penjelasan lengkap dan kode yang bisa langsung dipakai." },
      { q: "Apakah AI bisa membantu debug kode saya?", a: "Ya! Paste kode Arduino kamu di chat dan jelaskan masalahnya. AI akan menganalisis, menemukan bug, dan memberikan kode yang sudah diperbaiki beserta penjelasannya." },
      { q: "Kenapa jawaban AI kadang terputus?", a: "Ini bisa terjadi karena koneksi internet lambat atau timeout server. Coba kirim ulang pesan atau refresh halaman chatbot. Pastikan koneksi internet stabil." },
      { q: "Apakah riwayat chat tersimpan?", a: "Riwayat chat tersimpan selama sesi berlangsung. Kamu bisa mulai chat baru dengan tombol Bersihkan di pojok kanan atas chatbot." },
    ],
  },
  {
    category: "📋 Template Kode",
    color: "#10B981",
    items: [
      { q: "Platform apa saja yang didukung template?", a: "AiDuNode mendukung 4 platform: Arduino Uno, Arduino Nano, NodeMCU ESP8266, dan ESP32. Setiap template dilengkapi daftar komponen, kode lengkap, dan penjelasan cara kerja." },
      { q: "Bagaimana cara filter template berdasarkan platform?", a: "Di halaman Template, klik tombol filter di bagian atas (Semua / Arduino / Arduino Nano / NodeMCU / ESP32) untuk menampilkan template sesuai platform yang kamu inginkan." },
      { q: "Bisakah saya menyalin kode dari template?", a: "Tentu! Klik kartu template untuk membuka detail, lalu klik tombol \"Salin Kode\" di tab Code. Kode akan langsung tersalin ke clipboard dan bisa kamu paste ke Arduino IDE." },
    ],
  },
  {
    category: "👤 Akun & Login",
    color: "#8B5CF6",
    items: [
      { q: "Bagaimana cara mendaftar akun baru?", a: "Klik \"Mulai Gratis\" di halaman utama, isi nama lengkap, email, dan password minimal 6 karakter, lalu klik \"Daftar\". Akun kamu akan langsung aktif." },
      { q: "Saya lupa password, bagaimana cara mereset?", a: "Di halaman Login, klik \"Lupa Password?\" lalu masukkan email yang terdaftar. Kamu akan mendapatkan link reset password melalui email tersebut." },
      { q: "Apakah data akun saya aman?", a: "Ya, data akun disimpan dengan enkripsi di server yang aman. Kami tidak pernah membagikan data pribadi pengguna kepada pihak ketiga." },
    ],
  },
  {
    category: "⚡ Teknis & Koneksi",
    color: "#F59E0B",
    items: [
      { q: "Aplikasi membutuhkan koneksi internet?", a: "Ya, fitur chatbot AI membutuhkan koneksi internet aktif untuk memproses pertanyaan. Namun template kode bisa dilihat tanpa koneksi setelah halaman dimuat." },
      { q: "Bagaimana cara melaporkan bug atau error?", a: "Hubungi tim kami via WhatsApp di +62 821-3289-6737 atau kirim email ke AiDuNode@gmail.com dengan subjek \"[BUG]\" diikuti deskripsi masalah. Tim kami akan merespons dalam 1–3 hari kerja." },
      { q: "Browser apa yang direkomendasikan?", a: "AiDuNode berjalan optimal di Chrome, Firefox, Edge, atau Safari versi terbaru. Pastikan JavaScript diaktifkan di browser kamu." },
    ],
  },
];

function FaqItem({ item, color }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="faq-item">
      <button className="faq-q" onClick={() => setOpen(v => !v)}>
        <span className="faq-q-text">{item.q}</span>
        <div className="faq-chevron" style={{ background: color + "20", color }}>
          {open ? "▲" : "▼"}
        </div>
      </button>
      {open && (
        <div className="faq-a" style={{ borderLeftColor: color }}>
          <p className="faq-a-text">{item.a}</p>
        </div>
      )}
    </div>
  );
}

export default function Bantuan() {
  const navigate = useNavigate();

  return (
    <DashboardLayout>
      <div className="help-page">

        {/* ── Header ── */}
        <div className="help-hero">
          <div className="help-hero-circles">
            <div className="help-circle1" />
            <div className="help-circle2" />
          </div>
          <button className="help-back-btn" onClick={() => navigate("/profil")}>← Profil</button>
          <div className="help-hero-icon">❓</div>
          <h1 className="help-hero-title">Pusat Bantuan</h1>
          <p className="help-hero-desc">Temukan jawaban, panduan, dan cara menghubungi tim kami.</p>
        </div>

        {/* ── Quick Actions ── */}
        <div className="help-section-label">
          <div className="help-section-pill" />
          <span>Aksi Cepat</span>
        </div>
        <div className="help-actions-grid">
          {QUICK_ACTIONS.map((a, i) => {
            const inner = (
              <div className="help-action-card" key={i}>
                <div className="help-action-icon" style={{ background: a.bg }}>
                  <span style={{ fontSize: 20 }}>{a.icon}</span>
                </div>
                <div className="help-action-body">
                  <div className="help-action-title" style={{ color: a.color }}>{a.title}</div>
                  <div className="help-action-desc">{a.desc}</div>
                </div>
                <span className="help-action-arrow" style={{ color: a.color }}>›</span>
              </div>
            );
            if (a.href) return <a href={a.href} target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none" }} key={i}>{inner}</a>;
            return <div key={i} onClick={() => navigate(a.to)} style={{ cursor: "pointer" }}>{inner}</div>;
          })}
        </div>

        {/* ── FAQ ── */}
        <div className="help-section-label" style={{ marginTop: 28 }}>
          <div className="help-section-pill" style={{ background: "#F59E0B" }} />
          <span>Pertanyaan Umum (FAQ)</span>
        </div>

        {FAQS.map((cat, ci) => (
          <div key={ci} className="faq-category">
            <div className="faq-cat-header" style={{ borderLeftColor: cat.color }}>
              <span className="faq-cat-title" style={{ color: cat.color }}>{cat.category}</span>
            </div>
            <div className="faq-list">
              {cat.items.map((item, ii) => (
                <FaqItem key={ii} item={item} color={cat.color} />
              ))}
            </div>
          </div>
        ))}

        {/* ── Kontak ── */}
        <div className="help-contact-card">
          <div className="help-contact-icon">🎧</div>
          <div className="help-contact-title">Masih butuh bantuan?</div>
          <div className="help-contact-desc">Tim kami siap membantu kamu 7 hari seminggu</div>
          <div className="help-contact-btns">
            <a href="https://wa.me/6282132896737" target="_blank" rel="noopener noreferrer" className="help-contact-btn wa">
              💚 WhatsApp
            </a>
            <a href="mailto:AiDuNode@gmail.com" className="help-contact-btn email">
              ✉️ Email
            </a>
          </div>
        </div>

      </div>
    </DashboardLayout>
  );
}
